const setActiveCableType = (type) => {
    return {
        type: 'SET_ACTIVE_CABLE_TYPE',
        payload: type
    };
};

const setActiveCableColor = (color) => {
    return {
        type: 'SET_ACTIVE_CABLE_COLOR',
        payload: color
    };
};

const setActiveCableLength = (length) => {
    return {
        type: 'SET_ACTIVE_CABLE_LENGTH',
        payload: length
    };
};

const setActiveCable = (cable) => {
    return {
        type: 'SET_ACTIVE_CABLE',
        payload: cable
    };
};

// eslint-disable-next-line
export default {
    setActiveCableType,
    setActiveCableColor,
    setActiveCableLength,
    setActiveCable
};
